import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/production/processFlowOrder'

/** 获取转派工序流转卡 */
export const getProcessFlowOrder = (params) => {
    return axios.get(`${rootApi}/searchListForTransfer`, {params})
  }

  /** 提交拆卡转派 */
export const transferConfirm = (params) => {
    return axios.post(`${rootApi}/transferConfirm`, params)
  }
  /** api */
  export const searchListapi = (params) => {
      return axios.post(`${rootApi}/searchList`,params,{dataType: 'json'})
    }